(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("iViewPro", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["iViewPro"] = factory(require("vue"));
	else
		root["iViewPro"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_38__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition